import React from 'react';
import PropTypes from 'prop-types';
import { makeStyles } from '@material-ui/core/styles';
import Typography from '@material-ui/core/Typography/Typography';

const useStyles = makeStyles(
  (theme) => ({
    title: {
      height:36,
      lineHeight:29 + "px",
    }
  }),
  {
    name: 'TitleDisplay',
  },
);

const TitleDisplay = (props) => {
    const {title, selectedVariant} = props;
    const classes = useStyles(props);
  return (
    <Typography variant="body1" className={classes.title}><b>{title}</b></Typography>
  );
};

TitleDisplay.propTypes = {
    title: PropTypes.string
};

TitleDisplay.defaultProps = {
};

export default TitleDisplay;
